module.exports = "https://www.niulinkcloud.com/_next/static/media/icon4.2047953fb3a9844d43d28b823e6d3d1e.png";